import React from 'react';
import {
    Grid, Row, Col,
} from 'react-bootstrap';

import SweetAlert from "react-bootstrap-sweetalert";
import QuestionPanels from './QuestionPanels.jsx';
import EvaluationPanel from './EvaluationPanel.jsx';
import IncubationService from "../../services/IncubationService";
import AlertError from '../Components/AlertError.jsx';

class PreEvaluate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proyectId: this.props.match.params.number,
      proyectInfo: null,
      alert: null,
      currentUser: null,
    };
    this.incubationService = new IncubationService();
    this.getPreEvaluation = this.getPreEvaluation.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.savePreEvaluation = this.savePreEvaluation.bind(this);
    this.confirmSave = this.confirmSave.bind(this);
  }

  componentWillMount() {
    const currentUser = this.incubationService.getProfile();
    this.setState({ currentUser });
  }

  componentDidMount() {
    this.getPreEvaluation(this.state.proyectId);
  }

  getPreEvaluation(id) {
    this.incubationService
      .getPreEvaluation(id)
      .then(res => {
        this.setState({ proyectInfo: res.evaluacion });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de la pre-evaluación, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }
  hideAlert() {
    this.setState({ alert: null });
  }
  confirmSave(data, score) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Guardar cambios?"
          onConfirm={() => this.savePreEvaluation(data)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí, guardar!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Está seguro de guardar la pre evaluación para ${this.state.proyectInfo.proyecto}?`}
          <p>Calificación Total: {score}</p>
          <small>Recuerde que no podrá volver a pre evaluar el proyecto</small>
        </SweetAlert>
      )
    });
  }

  savePreEvaluation(data) {
    this.incubationService
      .savePreEvaluation(this.state.proyectId, data)
      .then(res => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Pre Evaluación guardada satisfactoriamente!</div>), 10);
        this.props.history.push("/incubation/");
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de la pre-evaluación, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  render() {
    if (!this.state.currentUser || !this.state.proyectInfo) {
      return (<div className="main-content"></div>);
    }

    if ((this.state.currentUser.roles[0] === 'Coordinador' ||
    this.state.currentUser.username === this.state.proyectInfo.aditionalInfo.username) && this.state.proyectInfo.aditionalInfo.estado === 'IDEA') {
      return (
        <div className="main-content">
          {this.state.alert}
           <Grid fluid>
             <Row>
               <Col md={7} >
                 <QuestionPanels proyectInfo={this.state.proyectInfo}/>
               </Col>
               <Col md={5}>
                 <EvaluationPanel
                   savePreEvaluation={this.confirmSave} evaluacion={this.state.proyectInfo.evaluacion}
                 />
               </Col>
             </Row>
           </Grid>
        </div>
      );
    } else if (this.state.proyectInfo.aditionalInfo.estado !== 'IDEA') {
      return (
        <div className="main-content">
          <SweetAlert
            warning
            style={{ display: "block" }}
            title="Proyecto pre-evaluado!"
            onConfirm={() => window.history.back()}
            confirmBtnBsStyle="info"
            confirmBtnText="Volver"
            bsSize="large"
          >
            <p>Solo puede pre-evaluar los proyectos una vez</p>
            <small>Si cree que esto es un error contacte al Administrador del sistema o al Coordinador</small>
          </SweetAlert>
        </div>
      );
    } else {
      return (
        <div className="main-content">
          <SweetAlert
            warning
            style={{ display: "block" }}
            title="Acceso restringido!"
            onConfirm={() => window.history.back()}
            confirmBtnBsStyle="info"
            confirmBtnText="Volver"
            bsSize="large"
          >
            {'No tiene permisos para pre-evaluar este proyecto!'}
            <p>Solo puede pre-evaluar los proyectos que le fueron asignados</p>
            <small>Si cree que esto es un error contacte al Administrador del sistema o al Coordinador</small>
          </SweetAlert>
        </div>
      );
    }
  }
}

export default PreEvaluate;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreEvaluate.jsx